class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    let offset = document.querySelector('.header-wrapper')?.getBoundingClientRect().bottom;

    if (innerWidth > 768) {
      const resultsMaxHeight =
        window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;

      document.querySelectorAll('[js-search-modal="content"]')?.forEach((element, index) => {
        element.style.setProperty('max-height', `${resultsMaxHeight}px`);
      });
    }
    /*
      If announcement banner is present, remove its height from the offset
      There is an odd issue on homepage when announcement banner is present where the offset is not calculated correctly
    */
    if (document.querySelector('.announcement-bar-section') && document.querySelector('.index')) {
      const announcementBannerHeight = document
        .querySelector('.announcement-bar-section')
        .getBoundingClientRect().height;
      offset = offset - announcementBannerHeight;
    }
    document.querySelectorAll('.modal__content:not(.search-modal)').forEach((modal) => {
      modal.style.top = offset + 'px';
    });
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
